import React from 'react';
import { Radio } from 'antd';

const RadioGroup = Radio.Group;

class IsobaricRadioGroup extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      value: ""
    };
  }

  componentDidMount(){
    let _value = this.props.parameters.isobaricList[0];
    // this will NOT trigger Table generation action, intended :)
    this.setState({
      value: _value
    });
  }

  componentDidUpdate(prevProp, prevState){
    let str1 = JSON.stringify(this.props.parameters);
    let str2 = JSON.stringify(prevProp.parameters);
    if(str1 !== str2){
      this.setState({
        value: this.props.parameters.isobaricList[0] || ""
      })
    }
  }
  
  // The indeterminate property can help you to achieve a 'check all' effect.
  onChange = (e) => {
    // update local state
    this.setState({
      value: e.target.value
    });

    // for the convenience of using checkbox & radio
    // I am saving everything into an array and pass to parent compoennt
    // by doing this
    // I will NOT have to change the rest of the code :)
    let _arr1 = [];
    _arr1.push(e.target.value);
    let _arr2 = generateDataSource(_arr1, this.props.isobaricLabelTable);
    // update top parent component state
    this.props.updateParameters({
      isobaricList: _arr1,
      isobaricTable: _arr2,
    });
  }

  render() {
    const {isobaricLabelList} = this.props;
    const {value} = this.state;
    return (
      <div>
        <RadioGroup
          value={value} 
          onChange={this.onChange}>
        {
          isobaricLabelList.map((value, index)=>{
            return (
              <Radio key={index} value={value.name}>{value.name}</Radio>
            )
          })
        }
        </RadioGroup>
      </div>
    )
  }
}

export default IsobaricRadioGroup;


// generate complete datasource for Table [{},{}]
// input: selected value
// output: full array to generate Table
function generateDataSource(array, isobaricData){
  let _array = [];
  let _arr = [];

  for (let i=0; i<isobaricData.length; i++){
    array.forEach((item)=>{
      if(item === isobaricData[i].isobaric.split("-")[0]){
        _array.push(isobaricData[i].isobaric);
      }
    });
  }

  for(let i = 0; i<_array.length; i++){
    let obj = {};
    obj['key'] = i;
    obj['tags'] = _array[i];
    obj['minus1'] = '0.0';
    obj['minus2'] = '0.0';
    obj['plus1'] = '0.0';
    obj['plus2'] = '0.0';
    // console.log(obj);
    _arr.push(obj);
  }

  return _arr;
}